import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { RegistrationActions } from '../../../store/_features/user/auth/auth.actions';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'app-verification-reminder',
  templateUrl: './verification-reminder.component.html',
  styleUrls: ['./verification-reminder.component.css']
})
export class VerificationReminderComponent implements OnInit, OnDestroy {
  public currentUser$: Observable<User>;
  public showReminder$: Observable<boolean>;
  public isResending$ = new BehaviorSubject<boolean>(false);
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private store: Store,
    private actions$: Actions
  ) {
    this.currentUser$ = this.authService.currentUser;
    this.showReminder$ = this.currentUser$.pipe(
      map(user => !!user && user.emailVerification?.status !== 'verified')
    );
  }

  ngOnInit(): void {
    // Listen for success/failure actions to update UI and show toast
    this.actions$.pipe(
      ofType(RegistrationActions.verificationEmailSent),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.isResending$.next(false);
      this.toastr.success('Verification email sent successfully!', 'Success');
    });

    this.actions$.pipe(
      ofType(RegistrationActions.verificationEmailFailed),
      takeUntil(this.destroy$)
    ).subscribe(({ error }) => {
      this.isResending$.next(false);
      this.toastr.error(error.message || 'Failed to resend verification email', 'Error');
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  resendVerification(): void {
    if (this.isResending$.value) return;

    this.isResending$.next(true);
    this.store.dispatch(RegistrationActions.sendVerificationEmail());
  }
}
